module.exports = function getResource(label) {
    let resources = { componentNotFound: 'Composant introuvable' };
    return resources[label];
};
